//NOTE autogenerated by export script
export {AdminBatchAPIService as AdminBatch} from './adminBatchAPI.service'
export {AdminCamerasService as AdminCameras} from './adminCameras.service'
export {AdminCollarsService as AdminCollars} from './adminCollars.service'
export {AdminConfigurationDevicesService as AdminConfigurationDevices} from './adminConfigurationDevices.service'
export {AdminDataLoggersService as AdminDataLoggers} from './adminDataLoggers.service'
export {AdminDropOffsService as AdminDropOffs} from './adminDropOffs.service'
export {AdminExternalSensorsService as AdminExternalSensors} from './adminExternalSensors.service'
export {AdminFirmwareVersionsService as AdminFirmwareVersions} from './adminFirmwareVersions.service'
export {AdminInternalRequestService as AdminInternalRequest} from './adminInternalRequest.service'
export {AdminMovebankService as AdminMovebank} from './adminMovebank.service'
export {AdminPaymentService as AdminPayment} from './adminPayment.service'
export {AdminTT4SensorsService as AdminTT4Sensors} from './adminTT4Sensors.service'
export {AdminTrapsService as AdminTraps} from './adminTraps.service'
export {AdminUsersService as AdminUsers} from './adminUsers.service'
export {BASE_PATH} from '../variables'
export {ApiModule} from '../api.module'
export {AdminItemsServices as AdminItems} from './adminItemsService'
export {AllServices as All} from './allService'